type Props = {
  openMapper: () => void;
  missingRequiredCount: number;
};

export default function BookingInspector({
  openMapper,
  missingRequiredCount,
}: Props) {
  const ready = missingRequiredCount === 0;

  return (
    <>
      <div className="rounded-xl border border-teal-500/20 bg-teal-500/10 p-4">
        <div className="text-sm font-semibold text-slate-950 dark:text-white">
          Create Shipment Booking
        </div>

        <p className="mt-2 text-sm leading-6 text-slate-600 dark:text-slate-400">
          Stuurt de gemapte payload naar de JDX booking API.
        </p>

        <div
          className={`mt-4 rounded-xl px-3 py-2 text-xs font-black ${
            ready
              ? "bg-emerald-500/10 text-emerald-700 dark:text-emerald-300"
              : "bg-orange-500/10 text-orange-700 dark:text-orange-300"
          }`}
        >
          {ready
            ? "Mapping compleet"
            : `${missingRequiredCount} verplichte velden missen`}
        </div>
      </div>

      <button
        type="button"
        onClick={openMapper}
        className="w-full rounded-xl bg-orange-500 px-5 py-3 text-sm font-black text-white shadow-lg shadow-orange-500/10 transition hover:-translate-y-[1px] hover:bg-orange-400"
      >
        Mapping instellen
      </button>
    </>
  );
}